import { createFrameFieldViewer } from "./frameFieldViewer.js";
import type { FrameFieldViewer, FrameFieldConfig, FrameField, FrameFieldViewerOptions } from "./frameFieldViewer.js";

export type CardViewerFieldConfig = FrameFieldConfig;
export type CardViewerField = FrameField;
export type CardViewerOptions = FrameFieldViewerOptions;
export type CardViewer = FrameFieldViewer;

const DEFAULT_FIELDS = ["pan", "expiry", "cvv"];

export function createCardViewer(options: CardViewerOptions): CardViewer {
  return createFrameFieldViewer("CardViewer", DEFAULT_FIELDS, options);
}
